export default "__VITE_ASSET__493f0f34__"